<template>
  <div id="payment">
    <div class="row align-items-center mb-3">
      <h5 class="font-weight-bold text-uppercase" style="margin: auto;">Notification</h5>
    </div>
    <div class="row card" v-if="Object.keys(datas).length>0">
      <div class="col-12 card-body" v-if="Object.keys(datas)">
        <table class="table table-bordered tablesorter table-hover tableLay">
          <tr>
            <th style="width:5%;">SL</th>
            <th style="width:20%;">Title</th>
            <th style="width:75%;">Message</th>
            <th style="width:10%;" class="text-center">Status</th>
          </tr>
          <tr v-for="(data, index) in datas" :key="index">
            <td>{{ (index++)+1 }}</td>
            <td>{{data.title}}</td>
            <td><p class="text-justify" v-html="data.body"></p></td>
            <td class="text-center">
              <button
                v-if="Number(data.status) === 0"
                type="button"
                class="notification-status unread"
                title="Mark as read"
                @click="markAsRead(data)"
              ><i class="fa fa-circle"></i></button>
              <span v-else class="notification-status read" title="Read"><i class="fa fa-check-circle"></i></span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-else class="card card-body bg-ligh text-center">No Notification Yet</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {},
      count: 0,
      errors: []
    };
  },
  methods: {
    getNotification() {
      this.$root.loading = true;
      axios
        .get("student/notifications")
        .then(response => {
          this.datas = response.data.notifications || [];
          this.$root.notification_unread_count = response.data.unread_count || 0;
        })
        .catch(errer => {})
        .then(always => {
          this.$root.loading = false;
        });
    },
    markAsRead(notification) {
      axios.post("student/notifications/read", { notification_id: notification.id })
        .then(() => {
          notification.status = 1;
          this.$root.notification_unread_count = Math.max(0, this.$root.notification_unread_count - 1);
        })
        .catch(() => {
          this.notification("Notification status could not be updated.", "error");
        });
    }
  },
  created() {
    this.getNotification();
    this.$root.loading = false;
  },
  updated() {
    if (Object.keys(this.datas).length < 1) {
      if (this.count <= 0) {
        this.getNotification();
      }
      this.count++;
    }
  }
};
</script>
<style>
  a{
    color:blue;
  }
  .notification-status {
    border: 0;
    background: transparent;
    padding: 4px;
    font-size: 18px;
    line-height: 1;
  }
  .notification-status.unread {
    color: #dc3545;
    cursor: pointer;
  }
  .notification-status.read {
    color: #28a745;
  }
</style>
